import React from 'react';

/**
 * Badge / status tag (spec §4). tone: live|pos|warn|neg|accent|mock. `dot` adds a 6px dot.
 */
const tones = {
  live: 'text-arc-pos bg-arc-pos-soft',
  pos: 'text-arc-pos bg-arc-pos-soft',
  warn: 'text-arc-warn bg-arc-warn-soft',
  neg: 'text-arc-neg bg-arc-neg-soft',
  accent: 'text-arc-accent-ink bg-arc-accent-soft',
  mock: 'text-arc-ink-3 bg-arc-paper-2',
};

const Badge = ({ tone = 'mock', dot = false, className = '', children, ...props }) => (
  <span
    className={[
      'inline-flex items-center gap-1.5 text-[11px] font-semibold rounded-arc-sm px-2.5 py-1',
      tones[tone] ?? tones.mock,
      className,
    ].join(' ')}
    {...props}
  >
    {dot && <span className="w-1.5 h-1.5 rounded-full bg-current" aria-hidden="true" />}
    {children}
  </span>
);

export default Badge;
